import { combineReducers, configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";

import { DEVELOPMENT } from "util/Dev";

import { solicitacaoCorrenteReducer } from "./SolicitacaoCorrente/SolicitacaoCorrente.reducer";
import { unidadesResponsaveisReducer } from "./UnidadesResponsaveis/UnidadesResponsaveis.reducer";
import { comentariosSolicitacaoReducer } from "./ComentariosSolicitacao/ComentariosSolicitacao.reducer";
import { pessoasReducer } from "./Pessoas/Pessoas.reducer";
import { solicitacoesReducer } from "./Solicitacoes/Solicitacoes.reducer";

import { unidadesUFCReducer } from "./UnidadesUFC/UnidadesUFC.reducer";
import { servidoresReducer } from "./Servidores/Servidores.reducer";
import { autorizacaoReducer } from "./Autorizacao/Autorizacao.reducer";
import { classificacaoReducer } from "./Classificacao/Classificacao.reducer";
import { notificacaoReducer } from "view/extrair/Notificacao/store/Notificacoes/Notificacoes.reducer";
import { avaliacaoReducer } from "./Avaliacao/Avaliacao.reducer";
import { useDispatch } from "react-redux";
import classificacaoSlice from "./Classificacao/classificacaoSlice";
import membroUnidadeSlice from "./MembroUnidade/membroUnidadeSlice";



const rootReducer = combineReducers({
  autorizacao: autorizacaoReducer,
  solicitacaoCorrente: solicitacaoCorrenteReducer,
  solicitacoes: solicitacoesReducer,
  unidadesResponsaveis: unidadesResponsaveisReducer,
  comentariosSolicitacao: comentariosSolicitacaoReducer,
  pessoas: pessoasReducer,
  unidadesUFC: unidadesUFCReducer,
  classificacoes: classificacaoReducer,
  classificacao: classificacaoSlice,
  servidores: servidoresReducer,
  notificacoes: notificacaoReducer,
  avaliacoes: avaliacaoReducer,
  membroUnidade: membroUnidadeSlice
});

export type RootState = ReturnType<typeof rootReducer>;

const windowRedux = window as any;
const middleware = getDefaultMiddleware({
  // FIXME - Descobrir pq `immutableCheck` não está funcionando adequadamente
  immutableCheck: false,
  // FIXME - Está reclamando muito por conta da convenção da data em dayjs
  serializableCheck: false
});


// Dispatch tipado - https://redux-toolkit.js.org/usage/usage-with-typescript#getting-the-dispatch-type
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();


export const store = configureStore({
  reducer: rootReducer,
  middleware: middleware,
  devTools: DEVELOPMENT && windowRedux.__REDUX_DEVTOOLS_EXTENSION__ !== undefined
});
